import React, { useState } from "react";
import { currentTheme, setTheme } from "@/lib/theme";

// Dark is the default; this switches to the light theme (and back) and remembers the choice.
export default function ThemeToggle({ className = "hs-icon-btn" }) {
  const [theme, set] = useState(currentTheme());
  const next = theme === "dark" ? "light" : "dark";
  return (
    <button type="button" className={className} data-testid="theme-toggle" aria-label={`Switch to ${next} theme`}
            onClick={() => { setTheme(next); set(next); }}>
      {next === "light" ? "Light" : "Dark"}
    </button>
  );
}
